<script>

    import { loginUser } from '/public/services/users/users.js';

    let email = null;
    let password = null;

    function processLogin(e) {
            e.preventDefault();

            loginUser(email, password).then(res =>  {
                if (res.success === true) {
                    window.location = res.data.url;
                }
            });

    }
</script>

<main>

<div class="card">
    <div class="card-header">
        Login
    </div>
    <div class="card-body">
    <form on:submit={processLogin} class="form-horizontal">
        <div class="form-floating mb-3">
            <input type="email" id="email" class="form-control" required bind:value={email} placeholder="Enter your email"/>
            <label for="name">
                Email Address
            </label>
        </div>
        <div class="form-floating mb-3">
            <input type="password" id="password" class="form-control" required bind:value={password} placeholder="Enter your password"/>
            <label for="password">
                Password
            </label>
        </div>
        <div class="mb-3">
                <button type="submit" class="btn btn-success">
                    <i class="fas fa-sign-in-alt"></i> login
                </button>
        </div>
        <div class="text-right">
            <a href="/forgot-my-password" >
                Forgot your password?
            </a>
        </div>
    </form>
    </div>
</div>


</main>

<style>

</style>
